import { render, staticRenderFns } from "./ListaCancellationReason.vue?vue&type=template&id=e371f65c"
import script from "./ListaCancellationReason.vue?vue&type=script&lang=js"
export * from "./ListaCancellationReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports